// CCTPv2 Fee Hook Contract Addresses
// These contracts receive USDC on destination chains and deduct fees
export const FEE_HOOK_ADDRESSES = {
  // Ethereum Mainnet
  1: {
    //address: '0x80ffc2f5aac3B68e7a0DF177a8d93378dBf478d7', // To be deployed
    //address: '0x084FEF05BD9D09426a101d61161525a811AaCD67',
    address: '0xB0C314E7C905119fdDB6Ea9d9Ed2deB8e3F79cfc',
    feePercentage: 5, // 0.3% = 30 basis points
  },
  // Avalanche C-Chain
  43114: {
    //address: '0x8c21bB0567E3E50Dc22e31b82d6592Bd89947dFa', // To be deployed
    //address: '0xe313F84D7fa98e6000a6B51E797C4C13E2322305',
    address: '0x64135471CF15A5159e404d21ed1D89aE03540A58',
    feePercentage: 0,
  },
  // Optimism
  10: {
    //address: '0x80ffc2f5aac3B68e7a0DF177a8d93378dBf478d7', // To be deployed
    //address: '0x084FEF05BD9D09426a101d61161525a811AaCD67',
    address: '0xB0C314E7C905119fdDB6Ea9d9Ed2deB8e3F79cfc',
    feePercentage: 5,
  },
  // Arbitrum One
  42161: {
    //address: '0x9aECb7436779c1784d074aeB343CeDABe88Fc0F9', // To be deployed
    //address: '0x1AB3233401F98EF3957797f479281eC922974898',
    address: '0xe6f9f7C6efaCf3C710fc3633fee9802c8D9037b1',
    feePercentage: 5,
  },
  // Base
  8453: {
    //address: '0x8D88bEE2D5b89c58da697C38364A9D64dE067ECb', // TODO: Replace with actual deployed address when available
    //address: '0x58Aa3854D77bDFB8822e36854e059eB24478B355',
    address: '0x6Fed75Ee5Ac3af9b989cC3A317C773DC655c9c06',
    feePercentage: 5,
  },
  // Polygon PoS
  137: {
    //address: '0x4758fcD3888c4A36ae99c0FAA9BA7bFDF2F0C518', // To be deployed
    //address: '0x5F15C11262C1b85Fa1a4701770b8C4B9270F4856',
    address: '0x9aECb7436779c1784d074aeB343CeDABe88Fc0F9',
    feePercentage: 5,
  },
  130: {
    //address: '0x80ffc2f5aac3B68e7a0DF177a8d93378dBf478d7', // To be deployed
    //address: '0xB0C314E7C905119fdDB6Ea9d9Ed2deB8e3F79cfc',
    address: '0xA3f6fAc8D7325aB9615e4f9c26B624da52661e59',
    feePercentage: 5,
  },
  // Linea
  59144: {
    //address: '0x80ffc2f5aac3b68e7a0df177a8d93378dbf478d7', // To be deployed
    //address: '0xB0C314E7C905119fdDB6Ea9d9Ed2deB8e3F79cfc',
    address: '0xA3f6fAc8D7325aB9615e4f9c26B624da52661e59',
    feePercentage: 10,
  },
  // Sonic
  146: {
    //address: '0x80ffc2f5aac3B68e7a0DF177a8d93378dBf478d7', // To be deployed
    //address: '0x084FEF05BD9D09426a101d61161525a811AaCD67',
    address: '0x3cf7b74A2cF34e71aa3ECA3bDeC43d2dEe491792',
    feePercentage: 5,
  },
};

// Helper function to get fee hook address for a chain
export function getFeeHookAddress(chainId) {
  const config = FEE_HOOK_ADDRESSES[chainId];
  return config ? config.address : null;
}

// Helper function to check if fee hook is enabled for a chain
export function isFeeHookEnabled(chainId) {
  const config = FEE_HOOK_ADDRESSES[chainId];
  return config && config.address !== null;
}
